import cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';

import { handleActions } from 'redux-actions';
import endpoints from '../../config/endpoints';
import http from '../shared/http';
import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';
import {SubmissionError} from 'redux-form';
import {createSelectOptionsFromSysEnums} from '../shared/form-elements/select';

// actions types
const FETCH_DATA_SUCCESS = 'exchange-rates/fetch-data-success';
const FETCH_DATA_ERROR = 'exchange-rates/fetch-data-error';

const UPDATE_RATES_SUCCESS = 'exchange-rates/update-rates-success';
const UPDATE_RATES_ERROR = 'exchange-rates/update-rates-error';

const CANCEL_CHANGES_SUCCESS = 'exchange-rates/cancel-changes';

const CHANGE_FORM_MODE = 'exchange-rates/change-form-mode';

// permissions
export const allowedPermissions = {
	view: 'exchange_rates_list',
	edit: 'exchange_rates_update'
};
// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	addFormMode: false,
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => dispatch => {
			const request = http({
				url: endpoints.EXCHANGE_RATE,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS]
			});
			return request(dispatch);
		},
		changeAddFormMode: () => ({
			type: CHANGE_FORM_MODE
		}),
		submitForm: (data) => dispatch => {
			const formData = {...data, currency: _get(data, 'currency[0].value', 'rub')};
			const request = http({
				url: endpoints.EXCHANGE_RATE,
				method: 'post',
				actions: [UPDATE_RATES_SUCCESS, UPDATE_RATES_ERROR],
				data: formData
			});
			return request(dispatch)
				.then((action) => {
					if (action.type === UPDATE_RATES_ERROR) {
						const submitErrors = {};
						action.payload.response.data.forEach(err => {
							submitErrors[err.dataPath.split('.').join('')] = err.message;
						});
						throw new SubmissionError(submitErrors);
					}
					dispatch(actions.changeAddFormMode());
					return actions.fetchData()(dispatch);
				});
		},
		cancelForm: () => ({type: CANCEL_CHANGES_SUCCESS})
	}
);

// reducers
const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({ ...state, error: false, data: action.payload.data }),
		[CANCEL_CHANGES_SUCCESS]: () => ({...initialState}),
		[CHANGE_FORM_MODE]: (state) => ({...state, addFormMode: !state.addFormMode}),
		[FETCH_DATA_ERROR]: (state) => ({ ...state, error: true })
	}
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => {
		return state.exchangeRates.data;
	},
	getCurrenciesOptions: state => {
		return createSelectOptionsFromSysEnums(state.root.lists['available-currencies'])
			.filter(curr => curr.value !== 'usd');
	},
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.exchangeRates.error,
	getAddFormMode: state => state.exchangeRates.addFormMode
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/exchange-rates/index.js